import * as React from "react";
import styled from "styled-components";
import { Img, WmkImage } from "wmk-image";
import { colors } from "../../../vars/palette";
import { IconCopyFields } from "../../../fragments/iconCopyFields";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";

const Wrap = styled.div`
  margin: 0.5rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  p {
    color: white;
    text-align: center;
    line-height: 1.5rem;
    font-family: "Nunito Sans";
    margin-top: 0;
  }
  h2 {
    text-align: center;
    font-size: 45px;
  }
  a {
    color: ${colors.hex("secondary")};
    display: inline !important;
  }
  a:hover {
    color: ${colors.hex("primary")};
  }
  @media only screen and (max-width: 575px) {
    margin: auto;
  }
`;
const ImageWrap = styled.div`
  height: 6.5rem;
  width: 6.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-left: 1rem
  // width: fit-content;
  // max-height: fit-content;
`;
const ContentWrap = styled.div`
  display: flex;
  justify-content: center;
  @media only screen and (max-width: 640px) {
    p {
      margin-right: 0 !important;
      margin-left: 0 !important;
      width: 100% !important;
    }
  }
`;

const BlockIconCopy = ({ block }: { block: IconCopyFields }) => {
  // const iconCopy = block?.copy;
  // console.log("block", block)
  const iconCopy = block?.copy?.copy;
  const icon = new Img(block.icon);
  return (
    <Wrap>
      <ImageWrap>
        <WmkImage image={icon} />
      </ImageWrap>
      {block.header && <h2>{block.header}</h2>}
      {iconCopy && (
        <ContentWrap className="icon-copy-text">
          <ReactMarkdown
          components={{
            a: ({ node, ...props }) => (
              <a
                target="_blank"
                {...props}
              />
            ),
          }}
        >{iconCopy}</ReactMarkdown>
        </ContentWrap>
      )}
    </Wrap>
  );
};

export default BlockIconCopy;
